import { useCallback, useState } from 'react';
import { usePageData } from '@/contexts/pageContext';
import { useUser } from '@/contexts/userContext';
import { applyMask } from '@/utils/applyMask';
import { removeNonDigits } from '@/utils/removeNonDigits';
import { useApplyBalance } from './useApplyBalance';
import { useGetLoyaltyCardBalance } from './useGetLoyaltyCardBalance';

const regex = /(\d{1,4})(\d{0,4})(\d{0,4})(\d{0,4})/;
const mask = '$1 $2 $3 $4';

export const useLoyaltyCard = () => {
  const { helpText } = usePageData();
  const { loyaltyCardId } = useUser();
  const initialCardNumber = applyMask({
    mask,
    regex,
    value: loyaltyCardId ?? '',
  });
  const [loyaltyCardNumber, setLoyaltyCardNumber] = useState(initialCardNumber);
  const [applyPoints, setApplyPoints] = useState(false);

  const cardNumberWithoutSpaces = removeNonDigits(loyaltyCardNumber);

  const loyaltyCardBalance = useGetLoyaltyCardBalance(cardNumberWithoutSpaces);
  const balanceMessage = loyaltyCardBalance
    ? `You have ${loyaltyCardBalance.pointsBalance} points available (worth ${loyaltyCardBalance.cashBalance}).`
    : '';

  const pointsBalance = loyaltyCardBalance?.pointsBalance ?? 0;
  const applyBalance = useApplyBalance(applyPoints);
  const handleApply = useCallback(
    (value: boolean) => {
      setApplyPoints(value);
      applyBalance({ loyaltyCardNumber: cardNumberWithoutSpaces });
    },
    [applyBalance, cardNumberWithoutSpaces],
  );

  const handleInputChange = (value: string) => {
    const cleanedValue = removeNonDigits(value);
    const maskedValue = applyMask({ mask, regex, value: cleanedValue });

    setLoyaltyCardNumber(maskedValue);
  };

  return {
    applyPoints,
    pointsBalance,
    balanceMessage,
    handleApply,
    handleInputChange,
    helpText,
    loyaltyCardNumber,
  };
};
